<ui-title [title]="'Anomalies'">

	<ui-loading class="col-lg-6 float-right" [loadingText]="'loading anomalies'" [loading]="anomalies.loading"></ui-loading>
</ui-title>

<ui-alert
		*ngIf="modalAlert.display"
		[title]="modalAlert.title"
		[text]="modalAlert.text"
		(onAction)="modalAlert.cb($event)"
	></ui-alert>

<div class="page-anomalies">

	<div class="col-lg-12">
		<ui-table [chunker]="anomalies.chunker" (chunked)="anomalies.chunkedData = $event" [filters]="true" [headers]="[
			{id: 'Id',style:'width: 75px',sortable:true, label: 'Id',filterable:true },
			{id: 'FirstName',style:'width: 125px',sortable:true, label: 'First Name',filterable:true,idFunction:getFirstNameFromRow},
			{id: 'LastName',style:'width: 125px',sortable:true, label: 'Last Name',filterable:true,idFunction:getLastNameFromRow},
			{id: 'LocalAlias',style:'width: 125px',sortable:true, label: 'Local Alias',filterable:true,idFunction:getLocalAliasFromRow},
			{id: 'SystemId',style:'width: 75px',sortable:true, label: 'System',type:'dropdown',filterable: true,options:{noEmptyChoice:false,choices:anomalies.availableSystems,emptyChoiceText:'(System)'}},
			{id: 'RoleName',style:'width: 125px',sortable:true, label: 'Role',type:'dropdown',filterable: true,options:{noEmptyChoice:false,choices:anomalies.availableRoles,emptyChoiceText:'(Role)'}},
			{id: 'reason',style:'width: 75px',sortable:true, label: 'Reason',filterable:true,idFunction:getTypeDescriptionFromRow},
			{id: 'Type',style:'width: 75px',sortable:true, label: 'Type',filterable:true,type:'dropdown',options:{noEmptyChoice:false,choices:anomalies.availableTypes,emptyChoiceText:'(Type)'},exactMatch:false,idFunction:getTypeFromRow},
			{id: 'CreatedDate',style:'width: 75px',sortable:true, label: 'Created',filterable:true,type:'date' }
  ]" [options]="{downloadAsExcel:true,refreshButton:true,onRefreshFunction:anomalies_load,onRefreshContext:self}">
			<tr *ngFor="let an of anomalies.chunkedData"
				[class]="'helper-clickable'"
				(click)="onSystemRowClick(an)"
			>
				<!-- total is 1080, 1g = 90 -->
				<td style="width: 90px;max-width: 90px;overflow-x: auto">{{an.Id}}</td>
				<td style="width: 130px;max-width: 130px;overflow-x: auto">{{an.FirstName}}</td>
				<td style="width: 130px;max-width: 130px;overflow-x: auto">{{an.LastName}}</td>
				<td style="width: 280px;max-width: 280px;overflow-x: auto">{{an.LocalAlias}}</td>
				<td style="width: 90px;max-width: 90px;overflow-x: auto">{{an.SystemName}}</td>
				<td style="width: 180px;max-width: 180px;overflow-x: auto">{{an.RoleName}}</td>
				<td style="width: 180px;max-width: 180px;overflow-x: auto">{{anomalies.descriptions[an.Type]}}</td>
				<td style="width: 90px;max-width: 90px;overflow-x: auto">{{anomalies.reasons[an.Type]}}</td>
				<td style="width: 90px;max-width: 90px;overflow-x: auto">{{an.CreatedDate|date}}</td>
			</tr>
		</ui-table>
	</div>

	<div class="col-lg-12 mt-4" *ngIf="anomalies.selected.Id">
		<div class="card">
			<div class="card-header">
				<h2>Anomaly
					{{anomalies.reasons[anomalies.selected.Type]}}
					-

					{{anomalies.descriptions[anomalies.selected.Type]}}

				</h2>
			</div>
			<div class="card-body ">
				<!-- Id-->
				<div class="form-group row">
					<label class="col-lg-2">
						Id
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.Id}}
					</div>
				</div>
				<!-- first name-->
				<div class="form-group row">
					<label class="col-lg-2">
						First Name
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.FirstName}}
					</div>
				</div>
				<!-- last name-->
				<div class="form-group row">
					<label class="col-lg-2">
						Last Name
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.LastName}}
					</div>
				</div>
				<!-- local alias, -->
				<div class="form-group row">
					<label class="col-lg-2">
						Local Alias
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.LocalAlias}}
					</div>
				</div>
				<!-- 	system,-->
				<div class="form-group row">
					<label class="col-lg-2">
						System
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.SystemName}}
					</div>
				</div>
				<!-- role-->
				<div class="form-group row">
					<label class="col-lg-2">
						Role
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.RoleName}}
					</div>
				</div>
				<!-- standard role name-->
				<div class="form-group row">
					<label class="col-lg-2">
						Standard Role Name
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.SystemRoleMappedName}}
					</div>
				</div>
				<!-- line maanager-->
				<div class="form-group row">
					<label class="col-lg-2">
						Line Manager
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.LineManagerFullName}}
					</div>
				</div>
				<!-- data load,-->
				<div class="form-group row">
					<label class="col-lg-2">
						Last Seen
					</label>
					<div class="col-lg-8">
						{{anomalies.selected.SystemBatchRowCreatedDate|date}}	{{anomalies.selected.SystemBatchRowCreatedDate|hoursandminutes}}
					</div>
				</div>

				<!-- Comments-->
				<div class="form-group row">
					<label class="col-lg-2">
						Comments
					</label>
					<div class="col-lg-8">
						<input type="text" class="form-control " name="system_comments_{{anomalies.selected.Id}}" placeholder="Comments" [(ngModel)]="anomalies.selected.Comments" />
						<button style =" margin-top: 5px;" mat-button class="btn-primary float-right" (click)="comments_save(anomalies.selected.Id, anomalies.selected.Comments)">
							Save
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<div class="float-right card mt-4" style="padding: 10px">
	<h5>
		Possible Anomalies
	</h5>
	<h6 *ngFor="let r of anomalies.reasons|kv" style="padding: 0;margin:0">
		<span class="material-icons" style="    font-size: 21px;
		position: relative;
		top: 5px;
		color: grey;" [matTooltip]="anomalies.descriptionsHowToSolve[r.key]">help</span>
		{{r.value}}
		-
		{{anomalies.descriptions[r.key]}}
		
	</h6>
</div>
